import React, { Component } from "react";
import "./App.css";
import AppRouter from "./router";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datetime/css/react-datetime.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      watching: true,
      code: null,
      token: null,
      user: null
    };
  }

  render() {
    return (
      <div>
        <ToastContainer transition={Zoom} />
        <AppRouter token={this.state.token} user={this.state.user} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js